<template>
  <div class="w-100 h-100">
  <welcome v-if="this.currentJob.state === 'draft'"></welcome>
  <component :is="dynamicComponent"></component>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import OneImageView from './Elements/OneImageView.vue';
import TwoImagesView from './Elements/TwoImagesView.vue';
import FourImagesView from './Elements/FourImagesView.vue';
import NineImagesView from './Elements/NineImagesView.vue';
import SixteenImagesView from './Elements/SixteenImagesView.vue';
import ImagesManager from '../../manager/ImagesManager';
import Welcome from "../Welcome.vue";

export default {
  name: "JobCanvas",
  props: {},
  components: {
    Welcome,
    OneImageView, 
    TwoImagesView, 
    FourImagesView, 
    NineImagesView, 
    SixteenImagesView 
  },
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {
    currentNumberOfImages() {
      const { batch_size, batch_count } = this.currentJob.settings.conversion.options;
      return ImagesManager.getByBatchSizeAndCount(batch_size, batch_count).number;
    },
    dynamicComponent() {
      // Determine which component to render based on currentNumberOfImages
      switch (this.currentNumberOfImages) {
        case 1:
          return 'OneImageView';
        case 2:
          return 'TwoImagesView';
        case 4:
          return 'FourImagesView';
        case 9:
          return 'NineImagesView';
        case 16:
          return 'SixteenImagesView'; 
        default:
          return 'OneImageView';
      }
    },
  }
};
</script>
<style lang="scss">
.result-img {
  cursor: pointer;
  border: 3px solid transparent;

  &:hover {
    border: 3px solid #1266F1;
  }
}

.image {
  object-fit: contain;
  height: 100%;
  display: flex;
  align-items: center;
  img {
    width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.loading {
  img {
    width: 100%;
    object-fit: contain;
  }
}

.loading,
.loading h4,
.loading .description {
  img {
    background-color: #383838;
    background: linear-gradient(
            100deg,
            rgba(255, 255, 255, 0) 40%,
            rgba(255, 255, 255, .1) 50%,
            rgba(255, 255, 255, 0) 60%
    ) #383838;
    background-size: 200% 100%;
    background-position-x: 180%;
    animation: 1s loading ease-in-out infinite;
  }
}

@keyframes loading {
  to {
    background-position-x: -20%;
  }
}
</style>
